import { MessagingExecutionType } from './messagingExecutionType';
import { TriggerKey } from '../userCommunicationAgent';

export enum FacebookPostKind {
  TEXT = 'TEXT',
  LINK = 'LINK',
  PHOTO = 'PHOTO',
}

export interface FacebookNewCommentTriggerConfig {
  /** Page id this trigger monitors. Enforced by the matcher, not only at creation. */
  pageId: string;
}

export interface FacebookNewMessageTriggerConfig {
  /** Page id this trigger monitors. Enforced by the matcher, not only at creation. */
  pageId: string;
  executionType: MessagingExecutionType;
  /** Minutes to wait for the conversation to go quiet. Only applies when executionType === DEBOUNCE. */
  debounceMinutes?: number;
}

export interface FacebookPublishPostStepConfig {
  kind: FacebookPostKind;
  /** Required for TEXT; optional caption for LINK and PHOTO. Supports template variables. */
  message?: string;
  /** Required for LINK. Supports template variables. */
  link?: string;
  /** Required for PHOTO. Public HTTPS. Supports template variables. */
  imageUrl?: string;
  /** ISO 8601 with an explicit timezone offset. Validated by parseScheduledAt. */
  scheduledAt?: string;
  /** Omit when the team has a single connected page. */
  pageId?: string;
}

export interface FacebookReplyCommentStepConfig {
  /** Reply text. Supports template variables. */
  message: string;
  /** Defaults to the triggering comment. Supports template variables. */
  commentId?: string;
  asPrivateReply?: boolean;
  pageId?: string;
}

export interface LoadFacebookPostsStepConfig {
  pageId?: string;
  limit?: number;
}

export interface LoadFacebookCommentsStepConfig {
  /** Defaults to the triggering comment's post. Supports template variables. */
  postId?: string;
  pageId?: string;
  limit?: number;
}

export interface SendFacebookMessageStepConfig {
  /**
   * PSID of the person the Page is replying to — NOT the conversation id
   * (LoadChatCommunicationsStepConfig's MESSENGER variant's conversationId is
   * a different kind of value). Defaults to the triggering message's sender.
   * Required at save time when the flow's trigger is not
   * FACEBOOK_NEW_MESSAGE. Supports template variables.
   */
  recipientId?: string;
  /** Message text. Supports template variables. */
  message: string;
  /** Defaults to the triggering Page. Required at save time when the team has several connected Pages. */
  pageId?: string;
}

export const FACEBOOK_TRIGGER_KEYS = [TriggerKey.FACEBOOK_NEW_COMMENT];

export const FACEBOOK_MESSENGER_TRIGGER_KEYS = [
  TriggerKey.FACEBOOK_NEW_MESSAGE,
];
